<template>
  <section>
    <div class="content_bg">
      <div class="content">
        <Caption label="배포" />
        <ul>
          <li>
            <SectionTechItem 
              :image="'tech_icon_action.png'"
              :record ="{
                text1:'Github Action',
                text2:'Github에 커밋하면 자동으로 빌드되어 배포됩니다',
              }"/>
          </li>
          <li>
            <SectionTechItem :image="'tech_icon_devil.png'"
              :record ="{
                text1:'Devil App Builder',
                text2:'앱에 대한 추가기능 및 버그수정은 앱배포 기다릴 필요없이 원격으로 로직이 수정되어 배포됩니다. 웹이 아니고 네이티브 코드 푸시입니다',
              }"/>
          </li>
        </ul>

        <div class="desc">
          모든 수정 요청은 가벼워야 합니다<br/>

          이를 위해서는 다양한 기술을 사용하고 있습니다만,
          그 중 하나는 배포 자동화입니다. <br/>

          서버, 관리자, 심지어 앱까지도 자동화 배포됩니다<br/>

          개발하는 과정도 자동으로 배포되서 프로젝트 시작 시점부터
          매일 확인하실수 있습니다

        </div>
      </div>
    </div>
  </section>
</template>
  
  <script>
import Caption from "./Caption.vue";
import SectionTechItem from "./SectionTechItem.vue";
export default {
  components: {
    Caption,
    SectionTechItem,
  },
  data() {
    return {};
  },
};
</script>
  
<style scoped>
.content_bg {
  display: inline-block;
  text-align: center;
  width: 100vw;
  height: fit-content;
  background-color: #ffffff;
  position: relative;
  overflow: hidden;
}

.content {
  display: inline-block;
  text-align: center;
  width: 100vw;
  height: 100%;
  max-width: 1140px;
  padding: 100px 20px 100px 20px;
}

.title_box {
  width: 272px;
}
ul {
  margin-bottom: 80px;
  width: 100%;
  justify-content: space-between;
  list-style-type: none;
  display: flex;
  flex-wrap: wrap;
  padding: 0;
}

ul li {
  margin-top: 50px;
  display: inline-block;
}

.desc {
  font-weight: 300;
  font-size: 24px;
  color: #000000;
}

@media screen and (max-width: 1440px) {
  .content_bg {
    display: inline-block;
    text-align: center;
    width: 100vw;
    height: fit-content;
    background-color: #ffffff;
    position: relative;
    overflow: hidden;
  }

  .content {
    display: inline-block;
    text-align: center;
    width: 100vw;
    height: 100%;
    max-width: 1140px;
    padding: 100px 20px 100px 20px;
  }

  .title_box {
    width: 272px;
  }
  ul {
    margin-bottom: 80px;
    width: 100%;
    list-style-type: none;
    display: block;
    text-align: center;
  }

  ul li {
    margin-top: 50px;
    width: fit-content;
    display: block;
    text-align: center;
  }
}
</style>
  